import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveSubaccount } from 'API';
import { selectAgaveSlice } from 'app/pages/store/agaveSlice';
import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { supportsCodeSort } from 'util/codingSortSetting';

interface AgaveSubaccountsDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedSubaccount?: AgaveSubaccount | null;
  onValueChange: (option: AgaveSubaccount | null) => void;
  placeholder?: string;
  enabled?: boolean;
}

const AgaveSubaccountsDropdown = ({
  disabled,
  disableHeader = true,
  selectedSubaccount,
  onValueChange,
  placeholder,
  enabled = true,
}: AgaveSubaccountsDropdownProps) => {
  // SEE-1622: label sub-accounts with their ERP code wherever code sorting is
  // supported — same gate as vendors; without it the label repeats the name
  // ("Consulting - (Consulting)") and code order reads as random.
  const { selectedPaidol } = useAppSelector(selectUserCompanies);
  const { agaveAccount } = useAppSelector(selectAgaveSlice);
  const showCode = supportsCodeSort(selectedPaidol, agaveAccount?.source_system?.slug);

  return (
    <CodingEntityDropdown<AgaveSubaccount>
      entityType="subaccounts"
      label="Subaccount"
      selectedItem={selectedSubaccount}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder}
      identifierField={showCode ? 'code' : 'name'}
      enabled={enabled}
    />
  );
};

export default AgaveSubaccountsDropdown;
